import { Socials } from "assets/data";
import { LanguageMetadataType } from "types";

import {
  en,
  fr,
  pt,
  sg,
  zh,
  ko,
  vi,
  th,
  de,
  it,
  ga,
  uk
} from "assets/locales";

export const REGIONS = {
  EN: "EN",
  FR: "FR",
  PT: "PT",
  SG: "SG",
  ZH: "ZH",
  KO: "KO",
  VI: "VI",
  TH: "TH",
  DE: "DE",
  IT: "IT",
  GA: "GA",
  UK: "UK"
};

export const LOCALE_STRINGS: Record<string, any> = {
  [REGIONS.EN]: en,
  [REGIONS.FR]: fr,
  [REGIONS.PT]: pt,
  [REGIONS.SG]: sg,
  [REGIONS.ZH]: zh,
  [REGIONS.KO]: ko,
  [REGIONS.VI]: vi,
  [REGIONS.TH]: th,
  [REGIONS.DE]: de,
  [REGIONS.IT]: it,
  [REGIONS.GA]: ga,
  [REGIONS.UK]: uk
};

export const DATE_FORMAT = {
  DEFAULT: {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  },
  YEAR_MONTH: {
    year: "numeric",
    month: "short",
  }
};

export const TIME_FORMAT = {
  DEFAULT: {
    hour: "2-digit",
    minute: "2-digit",
  }
};

export const INPUT_MASK = {
  DATE: "9999-99-99",
  PHONE: "(999) 999-9999"
};

export const TEXTAREA = {
  MAX: 5,
  MIN: 3
};

export const MAX_INTEGER = 2147483647;
export const SEPARATOR = " — ";

const githubSocial = Socials?.find((s) => s.name.toLowerCase() === "github");
const githubHref = githubSocial?.href || "https://github.com/sergio-righi/";
const githubUsername = githubHref.replace(/^https?:\/\/github\.com\//, "").replace(/\/$/, "");

export const GITHUB = {
  BASE_URL: "https://api.github.com",
  USERNAME: githubUsername,
  REPOS_URL: `https://api.github.com/users/${githubUsername}/repos`,
};

export const LANGUAGE_LIST: LanguageMetadataType[] = [
  { code: "EN", flagCode: "CA", nativeName: "English" },
  { code: "FR", flagCode: "FR", nativeName: "Français" },
  { code: "PT", flagCode: "BR", nativeName: "Português" },
  { code: "SG", flagCode: "SG", nativeName: "Singlish" },
  { code: "ZH", flagCode: "CN", nativeName: "简体中文" },
  { code: "KO", flagCode: "KR", nativeName: "한국어" },
  { code: "VI", flagCode: "VN", nativeName: "Tiếng Việt" },
  { code: "TH", flagCode: "TH", nativeName: "ภาษาไทย" },
  { code: "DE", flagCode: "DE", nativeName: "Deutsch" },
  { code: "IT", flagCode: "IT", nativeName: "Italiano" },
  { code: "GA", flagCode: "IE", nativeName: "Gaeilge" },
  { code: "UK", flagCode: "UA", nativeName: "Українська" },
];